import React from 'react';

const FormCheckBox = function (props) {
  const {
    text, image, ...rest
  } = props;
  return (
    <label>
      {image && <img src={image} alt={text} />}
      <input
        type="checkbox"
        {...rest}
        onChange={() => { /* let event bubble */ }}
      />
      <div className="name">{text}<span className="checkmark" /></div>
    </label>
  );
};

export default FormCheckBox;



// WEBPACK FOOTER //
// ./src/pages/Helpers/Form/FormCheckBox.js